import {createContext} from "react";
import {Resource, ResourceAccessRole} from "./types";

export type ResourceContextProps = {
  accessRole?: ResourceAccessRole,
  resources: Resource[],
  selectedResource: Resource,
  setSelectedResource: (resource: Resource) => void
};

export const ResourceContext = createContext<ResourceContextProps>(null);